import { HostedSites } from './league'

export enum CurrentProgressState {
  IN_PROGRESS = 'progress-loading',
  SUCCESS = 'progress-success',
  ERROR = 'progress-error',
}
export enum FantasyProvider {
  SLEEPER = 'Sleeper',
  ESPN = 'ESPN',
  YAHOO = 'Yahoo!',
  MANUAL = 'Manual',
}

export const HostedSiteToFantasyProvider = {
  [HostedSites.SLEEPER]: FantasyProvider.SLEEPER,
  [HostedSites.ESPN]: FantasyProvider.ESPN,
  [HostedSites.YAHOO]: FantasyProvider.YAHOO,
  [HostedSites.NONE]: FantasyProvider.MANUAL,
}

type FantasyProviderConfigType = {
  [key: string]: {
    name: string
    logo: string
    shortLogo: string
    syncHeaderText: string
    syncExplainerText?: string
    inputText?: string
    placeholderExplainerText?: string
    uid: string
    explainerImage?: string
    additionalText?: string
  }
}
export const FantasyProviderConfig: FantasyProviderConfigType = {
  [FantasyProvider.MANUAL]: {
    name: 'Manual',
    logo: 'manual-league-logo',
    shortLogo: 'manual-short-icon',
    syncHeaderText: 'Add Your League',
    syncExplainerText: `You can select from one of our pre-defined scoring systems.`,
    inputText: '',
    placeholderExplainerText: '',
    uid: 'league url',
  },
  [FantasyProvider.ESPN]: {
    name: 'ESPN',
    logo: 'espn-long-icon',
    shortLogo: 'espn-short-icon',
    syncHeaderText: 'Select League',
    syncExplainerText: `Select the league you want to sync to your PFF account. You'll be able to sync more leagues from your account later.`,
    uid: 'teamname',
  },
  [FantasyProvider.YAHOO]: {
    name: 'Yahoo',
    logo: 'yahoo-long-icon',
    shortLogo: 'yahoo-short-icon',
    syncHeaderText: 'Select League',
    syncExplainerText: `Select the league you want to sync to your PFF account. You'll be able to sync more leagues from your account later.`,
    uid: 'teamname',
  },
  [FantasyProvider.SLEEPER]: {
    name: 'Sleeper',
    logo: 'sleeper-long-icon',
    shortLogo: 'sleeper-short-icon',
    syncHeaderText: 'Sleeper Fantasy Football',
    syncExplainerText: 'Enter your sleeper username.',
    inputText: 'Sleeper username',
    placeholderExplainerText: 'Your Sleeper username',
    uid: 'username',
  },
}
